import type { UnitDefinition } from "@src/types/units";

/** Display label: symbol (fallback name), empty when the unit is unknown. */
export const unitLabelOf = (
  unit: UnitDefinition | null | undefined,
): string => {
  const text = unit?.unit_text?.eng ?? Object.values(unit?.unit_text ?? {})[0];
  return text?.symbol || text?.name || "";
};
